import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileService } from '../../services/file.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'egi-file-btn-group',
  templateUrl: './file-btn-group.component.html',
  styleUrls: ['./file-btn-group.component.css'],
})
export class FileBtnGroupComponent implements OnInit {
  @Input() file: any;
  @Input() deleteFunc: (params: any[]) => Observable<void>;
  @Input() params: any[] = [];
  @Input() showEdit: boolean = false;
  @Input() currentPath: { uuid: string; name: string; parent: string }[] = [];
  @Input() limitToFolder;

  @Output() delete = new EventEmitter();
  @Output() edit = new EventEmitter();

  previewUrl;
  fileType;
  deleting = false;
  downloading = false;
  editModal: boolean = false;
  fileName: string = '';
  saving: boolean = false;

  constructor(
    private fileService: FileService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.fileName = this.file.name;
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
    if (imageTypes.includes(this.file.name.split('.').pop())) {
      this.fileType = 'image';
    } else if (this.file.name.split('.').pop() === 'pdf') {
      this.fileType = 'pdf';
    } else {
      this.fileType = 'other';
    }
  }

  previewFile() {
    if (this.fileType !== 'other') {
      this.fileService.getPreviewUrl(this.file).subscribe(
        (url) => {
          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            url.previewUrl,
          );
        },
        (error) => {
          console.error('Error getting preview:', error);
        },
      );
    } else {
      this.previewUrl =
        'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf';
    }
  }

  downloadFile() {
    this.downloading = true;
    this.fileService.downloadFile(this.file).subscribe(
      (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.file.name; // Ensure correct filename
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.downloading = false;
      },
      (error) => {
        console.error('Error downloading file:', error());
      },
    );
  }

  deleteFile() {
    if (
      confirm(
        `Are you sure you want to delete this file/folder (${this.file.name})?`,
      )
    ) {
      this.deleting = true;
      if (this.deleteFunc) {
        this.deleteFunc(this.params).subscribe((res) => {
          this.delete.emit(res);
          this.deleting = false;
        });
      } else {
        this.fileService.deleteFile(this.file).subscribe(
          () => {
            this.delete.emit();
            this.deleting = false;
          },
          (error) => {
            console.error('Error deleting file:', error);
          },
        );
      }
    }
  }
  handleClose() {
    this.previewUrl = undefined;
  }

  handleEditClose() {
    this.editModal = false;
  }

  onCurrentPathChange(event: any) {
    this.currentPath = event;
  }

  onSave() {
    this.saving = true;
    this.file.name = this.fileName;
    this.file.parent = this.currentPath[this.currentPath.length - 1].uuid;

    this.fileService.updateFile(this.file).subscribe((res) => {
      this.saving = false;
      this.edit.emit();
      this.handleEditClose();
    });
  }
}
